<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <v-layout wrap>
          <v-flex xs12 px-3 pt-3>
            <div class="title">
              Encuestas UG | Diseñar Encuesta
            </div>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text class="mt-3 px-6">
        <div v-if="loading">
          <v-row>
            <v-col
              key="sl_adminEncuesta_infoEncuesta"
              cols="12"
            >
              <v-skeleton-loader type="image" />
            </v-col>
          </v-row>
          <br>
          <v-row>
            <v-col
              key="sl_adminEncuesta_infoEncuesta"
              cols="12"
            >
              <v-skeleton-loader type="image" />
            </v-col>
           <!--  <v-col
              v-for="i in [1, 2, 3, 4, 5, 6]"
              :key="'sl_adminEncuesta_secciones_' + i"
              cols="4"
              md="2"
            >
              <v-skeleton-loader type="chip" />
            </v-col> -->
          </v-row>
          <!-- <br>
          <v-row>
            <v-col
              v-for="i in [1, 2, 3]"
              :key="'sl_adminEncuesta_preg_' + i"
              cols="12"
            >
              <v-skeleton-loader type="article" />
            </v-col>
          </v-row> -->
        </div>
        <inicio-disenar-encuesta v-else-if="valido && !loading" :id-servicio="intIdServicio" :id-encuesta="intIdEncuesta" :token="token"></inicio-disenar-encuesta>
        <v-alert 
            v-else 
            type="error">
            Usted no cuenta con el permiso para acceder a esta página.
        </v-alert>
      </v-card-text>
    </v-card>

    <v-snackbar
        key="snackbar_administrarencuesta"
        v-model="snackbarError"
        :bottom="true"
        :multi-line="true"
        color="error"
    >
      {{ textoError }}
      <v-btn 
        dark 
        text 
        @click="snackbarError = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "DisenarEncuesta",
  components: {
    InicioDisenarEncuesta: () =>
      import("../components/disenarEncuesta/InicioDisenarEncuesta"),
  },
  props: {
    idServicio: {
      type: String,
      required: false,
      default: ''
    },
    idEncuesta: {
      type: String,
      required: true,
    },
    token: {
      type: String,
      required: true,
    },
    
  },
  data () {
    return {
      settings: {
        maxScrollbarLength: 60
      },
      valido: false,
      loading: true,
      snackbarError: false,
      textoError: "",
    };
  },
  computed: {
    intIdServicio () {
      return this.idServicio == '' ? 0 : parseInt(this.idServicio)
    },
    intIdEncuesta () {
      return this.idEncuesta == '' ? 0 : parseInt(this.idEncuesta)
    },
  },
  beforeMount () {},
  async mounted () {
    this.validarAcceso();
  },
  methods: {
    ...mapActions(['tienePermisoServicio', 'tieneRolEncuesta']),
    async validarAcceso () {
      var self = this;
      self.loading = true;
      self.valido = false;

      self.snackbarError = false;
      self.textoError = "";
      
      if(await self.tienePermisoServicio({permiso: 'Administrador Encuestas'}) == true ||
         await self.tieneRolEncuesta({idEncuesta: self.intIdEncuesta, rol: 'Diseñar'}) == true
      ){
        self.valido = true;
        self.loading = false;
      } else {
        self.loading = false;
        self.valido = true;
      }

    }
  }
};
</script>

<style>
.card-ug {
  border: 1px solid #b5a36a !important;
}

.azul-ug {
  color: #0e345b !important;
}
</style>
